var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserguidesConductor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-userguides-conductor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.31,13.62a6.31,6.31,0,0,0-12.63,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15,
    cy: 2.87,
    r: 2.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,13.62a6.3,6.3,0,0,0-6.31-6.31,6.83,6.83,0,0,0-3.38.94,7.55,7.55,0,0,1,2.25,5.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.69,
    cy: 2.87,
    r: 2.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.69,8.25a6.09,6.09,0,0,0-3.37-.94A6.3,6.3,0,0,0,0,13.62H7.44A7.55,7.55,0,0,1,9.69,8.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.31,
    cy: 2.87,
    r: 2.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,14.75v.63A15.09,15.09,0,0,0,15,30,15.09,15.09,0,0,0,30,15.38v-.62Zm14.38,9.06v4.87c-1.63-.37-3.12-2.19-4.13-4.87ZM9.81,22.56A29.4,29.4,0,0,1,8.75,16h5.63v6.56Zm5.81,6.13V23.81h4.13C18.75,26.5,17.25,28.31,15.63,28.69Zm0-6.13V16h5.63a23.26,23.26,0,0,1-1.06,6.56ZM7.5,16a26.28,26.28,0,0,0,1,6.56H3.56A13.53,13.53,0,0,1,1.31,16Zm-3,7.81H8.87a13,13,0,0,0,2.56,4.44A13.9,13.9,0,0,1,4.5,23.81Zm14.06,4.44a13.61,13.61,0,0,0,2.56-4.44H25.5A13.9,13.9,0,0,1,18.56,28.25Zm7.87-5.69H21.5a29.51,29.51,0,0,0,1-6.56h6.19A13.53,13.53,0,0,1,26.44,22.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserguidesConductor);
export default __webpack_public_path__ + "static/media/icon-userguides-conductor.e3f2a16d3520db69d7447a6f23c62a76.svg";
export { ForwardRef as ReactComponent };